import axios from "axios"
import { withServerCache } from "utils/serverCache"

export default async function getEvents() {
    return withServerCache(
        "events-list",
        async () => {
            const { data } = await axios.get(`${process.env.NEXT_PUBLIC_API_URL_V2}events`)

            if (data) {
                return data
            } else {
                throw new Error("Failed to fetch events")
            }
        },
        2 * 60 * 1000 // 2 minutes TTL
    )
}

